export default queryObj => !Object.keys(queryObj).length ? '' : `?${Object.keys(queryObj).map(val =>
  `${val}=${(queryObj[val] && typeof queryObj[val] === 'object' ?
    JSON.stringify(queryObj[val]) :
    queryObj[val])}`)
  .join('&')}`;



// WEBPACK FOOTER //
// ./shared/lib/queryify.js